import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "post-no": () => import("/opt/buildhome/repo/app/middleware/post-no.ts"),
  "profile-member-no": () => import("/opt/buildhome/repo/app/middleware/profile-member-no.ts")
}